import { ReactNode } from 'react';
import styles from './styles.module.css';
import Footer from '../common/Footer';
import logo from '../../assets/images/green-logo.svg';
import TextLink from '../common/TextLink';
import classNames from 'classnames';

type Props = {
  /** お知らせ要素 */
  announce?: ReactNode;
  /** 画面名 (省略した場合はロゴが表示される) */
  title?: string;
  /** 画面名の高さをロゴと同じ高さにする */
  titleHeightIsTheSameAsLogo?: boolean;
  /** 〇〇画面へ戻るボタン要素の表示切り替え */
  goBack?: 'login';
  /** 〇〇画面へ戻るボタン要素のマージンを消す */
  noGoBackBottomMargin?: boolean;
  /** ホワイトエリアを広めにする */
  wide?: boolean;
  children?: ReactNode;
};

/**
 * ログイン系の画面 (ログイン画面などの中央にフォームがある) レイアウト
 */
function LoginLayout({
  announce,
  title,
  titleHeightIsTheSameAsLogo,
  goBack,
  noGoBackBottomMargin,
  wide,
  children,
}: Props) {
  return (
    <div className={styles.host}>
      <div className={styles.announce}>
        {announce}
        {announce && <div className={styles.announceBottomMargin} />}
      </div>
      <div className={styles.center}>
        <Title title={title} logoHeight={titleHeightIsTheSameAsLogo} />
        <div className={classNames(styles.box, wide && styles.wide)}>
          {children}
        </div>
        <GoBack goBack={goBack} noBottomMargin={noGoBackBottomMargin} />
      </div>
      <footer className={styles.footer}>
        <Footer />
      </footer>
    </div>
  );
}

export default LoginLayout;

function Title({
  title,
  logoHeight,
}: {
  title?: string;
  logoHeight?: boolean;
}) {
  if (title)
    return (
      <div
        className={classNames(
          styles.textTitle,
          logoHeight && styles.logoHeight
        )}
      >
        {title}
      </div>
    );
  return (
    <img className={styles.logoTitle} width={292} height={82} src={logo} />
  );
}

function GoBack({
  goBack,
  noBottomMargin,
}: {
  goBack?: 'login';
  noBottomMargin?: boolean;
}) {
  if (!goBack) return null;
  switch (goBack) {
    case 'login':
      return (
        <div
          className={classNames(
            styles.goBack,
            noBottomMargin && styles.noBottomMargin
          )}
        >
          <TextLink to={'/login'}>ログイン画面へ戻る</TextLink>
        </div>
      );
    default:
      throw new Error(`Unknown screen to back: ${goBack}`);
  }
}
